/**
 * @description: 商品销售明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="gsr-sxm-report">
        <div class="xm-list">
            <p class="p-hint">注：当天营业数据就只能单个营业日，历史数据支持两个月内的数据查询</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="time">
                        <input type="text" class="form-control laydate-icon" v-model="startTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="endTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="shop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-4">包厢区域:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择包厢区域" v-model="xm_room_area"
                        ref="xm_room_area" readonly @click="roomAreaFun()">
                    <span class="selection-clear" @click="clear_input('roomAreaFun')">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-3">包厢号:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xm_box" data-placeholder="请选择包厢号"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-3">操作人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xm_admin" data-placeholder="请选择操作人"></select>
                </div>
                <label class="list-label-4">订单类型:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择订单类型" v-model="ordertype" ref="ordertype"
                        readonly @click="ordertype_fun($event)">
                    <span class="selection-clear" @click="clear_input('ordertype_fun')">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-4">支付类型:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择支付类型" v-model="paymenttype"
                        ref="paymenttype" readonly @click="paymenttype_fun($event)">
                    <span class="selection-clear" @click="clear_input('paymenttype_fun')">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-4">商品类型:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择商品类型" v-model="xm_gtype_txt"
                        ref="xm_gtype_txt" @click="xmGtypeFun($event)" readonly>
                    <span class="selection-clear" @click="clear_input('xm_gtype_txt')">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">导购员工:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="xm_order_staff" data-placeholder="请选择导购员工"></select>
                </div>
                <label class="list-label-4">商品名称:</label>
                <div class="col-md-3">
                    <!-- <input class="form-control" placeholder="请输入商品名称" v-model="xm_goods_name"> -->
                    <el-input placeholder="请输入商品名称" size="small" v-model="xm_goods_name" v-if="blur_query">
                        <template slot="append">
                            <el-checkbox v-model="blur_query">模糊检索</el-checkbox>
                        </template>
                    </el-input>
                    <el-autocomplete placeholder="请选择商品" size="small" v-model="xm_goods_name"
                        :fetch-suggestions="querySearchGood" @select="handleSelectGood" v-else>
                        <template slot-scope="{ item }">
                            <div class="name">{{ item.name }}</div>
                        </template>
                        <template slot="append">
                            <el-checkbox v-model="blur_query">模糊检索</el-checkbox>
                        </template>
                    </el-autocomplete>
                </div>
                <label class="list-label-4">会员卡号:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入会员卡号" v-model="xm_vip_card">
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="xm_tit_sel">
                        <option value="1">员工</option>
                        <option value="2">艺人</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="xm_con_val" placeholder="请输入预订人姓名">
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">销售类型:</label>
                <div class="col-md-2">
                    <el-select v-model="info_type" placeholder="请选择销售类型" size="small" clearable>
                        <el-option value="1" label="仅单品销售（不含商品套餐/开房套餐内商品）"></el-option>
                        <el-option value="2" label="仅套餐销售内商品（不含赠送的套餐内商品）"></el-option>
                        <el-option value="3" label="仅赠送（包含赠送单品和赠送套餐内商品）"></el-option>
                    </el-select>
                </div>
                <label class="list-label-4">包厢类型:</label>
                <div class="col-md-2">
                    <el-select v-model="room_type_ids" size="small" placeholder="请选择包厢类型" clearable>
                        <el-option v-for="item in room_type_list" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </div>
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="getOrderList(1)"
                        style="margin-right: 10px">查询</button>

                    <button type="button" class="btn btn-flat btn-small btn-border-gray"
                        @click="getXmExportSet">导出</button>
                </div>
            </div>
            <div class="row">
                <label class="list-label-6">销售数量合计:</label>
                <div class="list-total" ref="xm_quantity"></div>
                <label class="list-label-6">销售总额合计:</label>
                <div class="list-total" ref="xm_sale"></div>
                <label class="list-label-6">成本总额合计:</label>
                <div class="list-total" ref="xm_buying"></div>
                <label class="list-label-6">利润总额合计:</label>
                <div class="list-total" ref="xm_profit"></div>
                <!-- <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getXmExportSet">导出</button>
                </div> -->
            </div>
            <!-- <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="orderlist"></table>
            </div> -->
            <el-table 
                v-loading="loading" 
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)" 
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}" 
                :data="list_table">
                <el-table-column prop="time" label="支付时间" width="110px"></el-table-column>
                <el-table-column prop="relation_id" label="订单编号" width="100px"></el-table-column>
                <el-table-column prop="order_type" label="订单类型"></el-table-column>
                <el-table-column prop="pay_platform" label="支付类型"></el-table-column>
                <el-table-column prop="vip_card" label="会员卡号" width="100px"></el-table-column>
                <el-table-column prop="vip_level_name" label="会员等级名称"></el-table-column>
                <el-table-column prop="room_area_name" label="包厢区域"></el-table-column>
                <el-table-column prop="room_type_name" label="包厢类型"></el-table-column>
                <el-table-column prop="room_name" label="包厢号"></el-table-column>
                <el-table-column prop="bill_no" label="账单号" width="130px"></el-table-column>
                <el-table-column prop="admin_name" label="操作人"></el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column prop="goods_name" label="商品名称" width="130px">
                    <template slot-scope="scope">
                        {{ scope.row.goods_name.length > '14' ? scope.row.goods_name.slice(0, 14) + '...' : scope.row.goods_name }}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="shopping_name" label="导购员工"></el-table-column>
                <el-table-column prop="book_admin_name" label="预定人"></el-table-column>
                <el-table-column prop="sale_quantity" label="净销售数量"></el-table-column>
                <el-table-column prop="quantity" label="销售数量"></el-table-column>
                <el-table-column prop="refund_quantity" label="退货数量"></el-table-column>
                <el-table-column prop="actual_pay" label="折后单价"></el-table-column>
                <el-table-column prop="buying_price" label="成本单价"></el-table-column>
                <el-table-column prop="actual_pay_total" label="折后总额"></el-table-column>
                <el-table-column prop="buying_price_total" label="成本总额"></el-table-column>
                <el-table-column prop="profit_price_total" label="利润总额"></el-table-column>
                <el-table-column prop="deduct_amount" label="提成金额"></el-table-column>
                <el-table-column prop="deduct_rate" label="提成百分比"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getOrderList">
            </el-pagination>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="xmExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='xmExport_allcheck' @click='xmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="time">
                            <label>支付时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="relation_id">
                            <label>订单编号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="order_type">
                            <label>订单类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="pay_platform">
                            <label>支付类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="vip_card">
                            <label>会员卡号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="vip_level_name">
                            <label>会员等级名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="room_area_name">
                            <label>包厢区域</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="room_name">
                            <label>包厢号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="bill_no">
                            <label>账单号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="admin_name">
                            <label>操作人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="shopping_name">
                            <label>导购员工</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="book_admin_name">
                            <label>预定人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="sale_quantity">
                            <label>净销售数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="quantity">
                            <label>销售数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="refund_quantity">
                            <label>退货数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="actual_pay">
                            <label>折后单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="buying_price">
                            <label>成本单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="actual_pay_total">
                            <label>折后总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="buying_price_total">
                            <label>成本总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="profit_price_total">
                            <label>利润总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="deduct_amount">
                            <label>提成金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="deduct_rate">
                            <label>提成百分比</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='xmExport_checkModel' value="room_type_name">
                            <label>包厢类型</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">

                        <li>
                            <input type="radio" v-model='xmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='xmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 包厢区域弹窗 -->
            <div class="ele-hide" ref="xm_area_alert">
                <div class="sel-seldiv">
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='xm_area_allcheck' v-on:click='xmAreaCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in xm_area_data" :key="item.id">
                            <input type="checkbox" v-model='xm_area_model' :value="item.id">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 订单类型弹窗 -->
            <div class="ele-hide" ref="ordertype_alert">
                <div class="sel-seldiv">
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='order_allcheck' v-on:click='orderCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='order_checkboxModel' value="1">
                            <label>酒水订单</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='order_checkboxModel' value="2">
                            <label>开房套餐</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='order_checkboxModel' value="4">
                            <label>续时套餐</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='order_checkboxModel' value="5">
                            <label>计时开房</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='order_checkboxModel' value="6">
                            <label>预买</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='order_checkboxModel' value="7">
                            <label>预买续时</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='order_checkboxModel' value="8">
                            <label>包断</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='order_checkboxModel' value="9">
                            <label>包断续时</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='order_checkboxModel' value="10">
                            <label>开房小吃</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='order_checkboxModel' value="11">
                            <label>扫码购买单</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='order_checkboxModel' value="12">
                            <label>限时秒杀</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 支付类型弹窗 -->
            <div class="ele-hide" ref="paymenttype_alert">
                <div class="set-export sel-seldiv">
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='payment_allcheck' v-on:click='paymentCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in xm_paytype" :key="item.id">
                            <input type="checkbox" v-model='payment_checkboxModel' :value="item.id">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 商品类型弹窗 -->
            <div class="ele-hide" ref="xm_gtype_area">
                <div class="set-export sel-seldiv">
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='xm_gtype_all' @click='xmGtypeAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in xm_gtype_data" :key="item.id">
                            <input type="checkbox" v-model='xm_gtype_item' :value="item.id">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                startTime: "",
                endTime: "",
                shopDatas: [],
                xm_room_area: '',
                xm_con_val: "",
                xm_area_allcheck: false,
                xm_c_area_allcheck: false,
                xm_area_model: [],
                xm_area_data: [],
                xm_goods_name: '',
                xm_vip_card: '',
                ordertype: "",
                order_allcheck: false,
                c_order_allcheck: false,
                order_checkboxModel: [],
                order_checkboxData: [{id: "1", name: "酒水订单"}, {id: "2", name: "开房套餐"}, {id: "4", name: "续时套餐"}, {id: "5", name: "计时开房"}, {id: "6", name: "预买"}, {id: "7", name: "预买续时"}, {id: "8", name: "包断"}, {id: "9", name: "包断续时"}, {id: "10", name: "开房小吃"}, {id: "11", name: "扫码购买单"}, {id: "12", name: "限时秒杀"}],
                paymenttype: "",
                payment_allcheck: false,
                c_payment_allcheck: false,
                payment_checkboxModel: [],
                xm_paytype: [],
                typeList: [],
                xm_gtype_txt: '',
                xm_gtype_all: false,
                c_xm_gtype_all: false,
                xm_gtype_data: [],
                xm_gtype_item: [],
                xmExport_allcheck: false,
                c_xmExport_allcheck: false,
                xmExport_checkModel: [],
                xmExport_checkData: ['time', 'relation_id', 'order_type', 'pay_platform', 'vip_card', 'vip_level_name', 'room_area_name', 'room_name', 'bill_no', 'admin_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'shopping_name', 'book_admin_name', 'sale_quantity', 'quantity', 'refund_quantity', 'actual_pay', 'buying_price', 'actual_pay_total', 'buying_price_total', 'profit_price_total', 'deduct_amount', 'deduct_rate', 'room_type_name'],
                xmExport_type: 1,
                xm_order_staff: '',
                info_type: '',
                blur_query: true,
                xm_goods_id: '',
                goods_list: [],
                room_type_list: [],
                room_type_ids: '',
                loading: false,
                list_page: 1,
                list_total: 0,
                list_table: [],
            }
        },
        watch: {
            xmExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.xmExport_checkModel.length >= this.xmExport_checkData.length) {
                        this.xmExport_allcheck = true;
                        this.c_xmExport_allcheck = true;
                    } else {
                        this.xmExport_allcheck = false;
                        this.c_xmExport_allcheck = false;
                    }
                },
                deep: true
            },
            xm_room_area: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.xm_room_area).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.xm_room_area).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            ordertype: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.ordertype).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.ordertype).parent().find('.selection-clear').hide();
                    }
                },
                deep:true
            },
            paymenttype: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.paymenttype).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.paymenttype).parent().find('.selection-clear').hide();
                    }
                },
                deep:true
            },
            xm_area_model: {
                handler: function (val, oldVal) {
                    if(this.xm_area_model.length >= this.xm_area_data.length) {
                        this.xm_area_allcheck = true;
                        this.xm_c_area_allcheck = true;
                    } else {
                        this.xm_area_allcheck = false;
                        this.xm_c_area_allcheck = false;
                    }
                },
                deep: true
            },
            order_checkboxModel: {
                handler: function (val, oldVal) {
                    if(this.order_checkboxModel.length >= this.order_checkboxData.length) {
                        this.order_allcheck = true;
                        this.c_order_allcheck = true;
                    } else {
                        this.order_allcheck = false;
                        this.c_order_allcheck = false;
                    }
                },
                deep: true
            },
            payment_checkboxModel: {
                handler: function (val, oldVal) {
                    if(this.payment_checkboxModel.length >= this.xm_paytype.length) {
                        this.payment_allcheck = true;
                        this.c_payment_allcheck = true;
                    } else {
                        this.payment_allcheck = false;
                        this.c_payment_allcheck = false;
                    }
                },
                deep: true
            },
            xm_gtype_txt: {
                handler: function(val,oldval) {
                    if(val != "") {
                        $(this.$refs.xm_gtype_txt).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.xm_gtype_txt).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            xm_gtype_item: {
                handler: function (val, oldVal) {
                    if(this.xm_gtype_item.length >= this.xm_gtype_data.length) {
                        this.xm_gtype_all = true;
                        this.c_xm_gtype_all = true;
                    } else {
                        this.xm_gtype_all = false;
                        this.c_xm_gtype_all = false;
                    }
                },
                deep: true
            },
            blur_query: {
                handler: function(val, oldval) {
                    if (val) {
                        this.xm_goods_id = ''
                    }else {
                        this.xm_goods_id = ''
                        this.xm_goods_name = ''
                    }
                },
                deep: true
            },
        },
        computed: {
            info_type_str() {
                if (this.info_type.length == 0) {
                    return ''
                }else if(this.info_type.length == this.info_type_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.info_type.forEach(v => {
                        this.info_type_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },
        },
        mounted: function() {
            // 日期
            this.startTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.endTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.typeList = [];
            this.getAllGoodsType(); // 商品类型
            // 下拉选项
            $(this.$refs.xm_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            });
            this.innitInput();  // 门店
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.startTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.endTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.startTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.endTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 61
                    }
                }, function(start, end, label) {
                    _this.startTime = start.format('YYYY-MM-DD HH:mm');
                    _this.endTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                // 操作人
                                _this.getAdmin(e.params.data.id);
                                if(e.params.data.text == "全部") {
                                    _this.xm_room_area = '';
                                    _this.xm_area_model = [];
                                    $(_this.$refs.xm_room_area).prop('disabled', true);
                                    // 消费包厢
                                    $(_this.$refs.xm_box).html("");
                                    $(_this.$refs.xm_box).prop("disabled", true);
                                    _this.paymenttype = '';
                                    _this.payment_checkboxModel = [];
                                    return;
                                }
                                $(_this.$refs.xm_room_area).prop('disabled', false);
                                _this.xm_room_area = '';
                                _this.xm_area_model = [];
                                _this.getRoomArea(e.params.data.id);
                                _this.getAllGoods(e.params.data.id);
                                _this.getRoomType(e.params.data.id);
                                // 消费包厢
                                $(_this.$refs.xm_box).prop("disabled", false);
                                _this.getRoomdata(e.params.data.id);

                                _this.paymenttype = '';
                                _this.payment_checkboxModel = [];
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.shop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.xm_room_area).prop('disabled', false);
                            _this.getRoomArea($(_this.$refs.shop).val());
                            _this.getAllGoods($(_this.$refs.shop).val())
                            // 消费包厢
                            $(_this.$refs.xm_box).prop("disabled", false);
                            _this.getRoomdata(data.response.result[1].id);
                            // 操作人
                            _this.getAdmin($(_this.$refs.shop).val());
                            // _this.innitTable();
                            _this.getOrderStaff($(_this.$refs.shop).val());
                            _this.setShopDefaultTime($(_this.$refs.shop).val());
                            _this.getOrderList(1);
                            // 包厢类型
                            _this.getRoomType($(_this.$refs.shop).val());
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢区域
            getRoomArea: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.xm_area_data = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢号
            getRoomdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.xm_box).html("");
                            $(_this.$refs.xm_box).select2({
                                data: roomDatas,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },
            // 获取操作人
            getAdmin: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.xm_admin).html("");
                            $(_this.$refs.xm_admin).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取支付类型
            getPaytype: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Order/getAllPayPlatform",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let paytype = [];
                            for(let [key, value] of Object.entries(data.response.data)) {
                                paytype.push({id: key, name: value});
                            }
                            _this.xm_paytype = paytype;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 全部商品类型
            getAllGoodsType: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {

                        }
                    },
                    "comment": []
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getAllGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.xm_gtype_data = data.response.result.data;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 全部商品
            getAllGoods: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": []
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getAllGoods",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.goods_list = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 获取导购员工
            getOrderStaff: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id,
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "user/getSearchList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: '全部' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.xm_order_staff).select2({
                                data: arr,
                                language: "zh-CN",
                                minimumResultsForSearch: -1,
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢类型
            getRoomType: function(shop_id) {
                const _this = this;
                Vue.axios.post('PublicData/api_getRoomType', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_type_list = res.data.response.result.data;
                        _this.room_type_list.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 清空多选
            clear_input: function(name) {
                if(name == 'ordertype_fun') {
                    this.ordertype = "";
                    this.order_checkboxModel = [];
                } else if(name == 'roomAreaFun') {
                    this.xm_room_area = "";
                    this.xm_area_model = [];
                } else if(name == 'paymenttype_fun') {
                    this.paymenttype = "";
                    this.payment_checkboxModel = [];
                } else if(name == 'xm_gtype_txt') {
                    this.xm_gtype_txt = "";
                    this.xm_gtype_item = [];
                }
            },



            // 包厢区域全选
            xmAreaCheckedAll: function() {
                let _this = this;
                _this.xm_area_allcheck = _this.xm_c_area_allcheck;
                if(!_this.xm_area_allcheck) { // 实现全选
                    _this.xm_area_model = [];
                    _this.xm_area_data.forEach(function(item) {
                        _this.xm_area_model.push(item.id);
                    });
                } else { // 实现反选
                    _this.xm_area_model = [];
                }
            },
            // 选择包厢区域
            roomAreaFun: function() {
                let _this = this;

                let xm_c_area_model = _this.xm_area_model;
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['包厢区域', true],
                    area: ['300px', ''], // 宽高
                    content: $(_this.$refs.xm_area_alert),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.xm_room_area != "") {
                            _this.xm_area_model = xm_c_area_model;
                            return;
                        }
                        _this.xm_room_area = [];
                    }
                }, function() {
                    let areaTxts = [];
                    _this.xm_area_data.forEach(function(item) {
                        _this.xm_area_model.forEach(function(item2) {
                            if(item.id == item2) {
                                areaTxts.push(item.name);
                            }
                        });
                    });
                    _this.xm_room_area = areaTxts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.xm_room_area != "") {
                        _this.xm_area_model = xm_c_area_model;
                        return;
                    }
                    _this.xm_area_model = [];
                });
            },
            // 选择订单类型
            ordertype_fun: function(e) {
                let _this = this;
                let c_order_checkboxModel = _this.order_checkboxModel;
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['订单类型', true],
                    area: ['300px', ''], // 宽高
                    content: $(_this.$refs.ordertype_alert),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.ordertype != "") {
                            _this.order_checkboxModel = c_order_checkboxModel;
                            return;
                        }
                        _this.order_checkboxModel = [];
                    }
                }, function() {
                    var orderTxts = [];
                    _this.order_checkboxData.forEach(function(item) {
                        _this.order_checkboxModel.forEach(function(item2) {
                            if(item.id == item2){
                                orderTxts.push(item.name);
                            }
                        });
                    });
                    _this.ordertype = orderTxts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.ordertype != "") {
                        _this.order_checkboxModel = c_order_checkboxModel;
                        return;
                    }
                    _this.order_checkboxModel = [];
                });
            },
            // 选择支付类型
            paymenttype_fun: function(e) {
                let _this = this;
                // 获取支付类型
                _this.getPaytype($(_this.$refs.shop).val(), 'xm');
                let c_payment_checkboxModel = _this.payment_checkboxModel;
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['支付类型', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.paymenttype_alert),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.paymenttype != "") {
                            _this.payment_checkboxModel = c_payment_checkboxModel;
                            return;
                        }
                        _this.payment_checkboxModel = [];
                    }
                }, function() {
                    var payTxts = [];
                    _this.xm_paytype.forEach(function(item) {
                        _this.payment_checkboxModel.forEach(function(item2) {
                            if(item.id == item2) {
                                payTxts.push(item.name);
                            }
                        });
                    });
                    _this.paymenttype = payTxts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.paymenttype != "") {
                        _this.payment_checkboxModel = c_payment_checkboxModel;
                        return;
                    }
                    _this.payment_checkboxModel = [];
                });
            },
            // 订单类型全选
            orderCheckedAll: function() {
                let _this = this;
                _this.order_allcheck = _this.c_order_allcheck;
                if(!_this.order_allcheck) { // 实现全选
                    _this.order_checkboxModel = [];
                    _this.order_checkboxData.forEach(function(item) {
                        _this.order_checkboxModel.push(item.id);
                    });
                } else { // 实现反选
                    _this.order_checkboxModel = [];
                }
            },
            // 支付类型全选
            paymentCheckedAll: function() {
                let _this = this;
                _this.payment_allcheck = _this.c_payment_allcheck;
                if(!_this.payment_allcheck) { // 实现全选
                    _this.payment_checkboxModel = [];
                    _this.xm_paytype.forEach(function(item) {
                        _this.payment_checkboxModel.push(item.id);
                    });
                } else { // 实现反选
                    _this.payment_checkboxModel = [];
                }
            },
            // 商品类型弹窗
            xmGtypeFun: function(e) {
                let _this = this;
                let c_xm_gtype_item = _this.xm_gtype_item;
                layer.confirm('', {
                    skin: 'timing_room_type',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['商品类型', true],
                    area: ['660px', ''], // 宽高
                    content: $(_this.$refs.xm_gtype_area),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.xm_gtype_txt != "") {
                            _this.xm_gtype_item = c_xm_gtype_item;
                            return;
                        }
                        _this.xm_gtype_item = [];
                    }
                }, function() {
                    let texts = [];
                    _this.xm_gtype_data.forEach(function(item) {
                        _this.xm_gtype_item.forEach(function(item2) {
                            if(item.id == item2) {
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.xm_gtype_txt = texts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.xm_gtype_txt != "") {
                        _this.xm_gtype_item = c_xm_gtype_item;
                        return;
                    }
                    _this.xm_gtype_item = [];
                });
            },
            // 全选
            xmGtypeAll: function() {
                let _this = this;
                _this.xm_gtype_all = _this.c_xm_gtype_all;
                if(!_this.xm_gtype_all) { // 实现全选
                    _this.xm_gtype_item = [];
                    _this.xm_gtype_data.forEach(function(item) {
                        _this.xm_gtype_item.push(item.id);
                    });
                } else { // 实现反选
                    _this.xm_gtype_item = [];
                }
            },
            // 初始化商品销售明细报表表格
            // innitTable: function() {
            //     let _this = this;
            //     $(_this.$refs.orderlist).bootstrapTable("destroy");
            //     $(_this.$refs.orderlist).bootstrapTable({
            //         pageNumber: 1,
            //         pageSize: 10,
            //         pageList: [],
            //         pagination: true,
            //         ajax: function(params) {
            //             _this.getOrderList(params);
            //         },
            //         sidePagination: "server",
            //         columns: [{
            //             field: "time",
            //             title: "支付时间",
            //             width: "100",
            //             valign: "middle"
            //         }, {
            //             field: "relation_id",
            //             title: "订单编号",
            //             width: "110",
            //             valign: "middle"
            //         }, {
            //             field: "order_type",
            //             title: "订单类型",
            //             valign: "middle"
            //         }, {
            //             field: "pay_platform",
            //             title: "支付类型",
            //             valign: "middle"
            //         }, {
            //             field: "vip_card",
            //             title: "会员卡号",
            //             width: "110",
            //             valign: "middle"
            //         }, {
            //             field: "vip_level_name",
            //             title: "会员等级名称",
            //             width: "100",
            //             valign: "middle"
            //         }, {
            //             field: "room_area_name",
            //             title: "包厢区域",
            //             valign: "middle"
            //         }, {
            //             field: "room_type_name",
            //             title: "包厢类型",
            //             valign: "middle"
            //         }, {
            //             field: "room_name",
            //             title: "包厢号",
            //             valign: "middle"

            //         }, {
            //             field: "bill_no",
            //             title: "账单号",
            //             width: "110",
            //             valign: "middle"
            //         }, {
            //             field: "admin_name",
            //             title: "操作人",
            //             valign: "middle"
            //         }, {
            //             field: "goods_type_name",
            //             title: "商品类型",
            //             valign: "middle"
            //         }, {
            //             field: "goods_name",
            //             title: "商品名称",
            //             width: "130",
            //             valign: "middle",
            //             formatter: function(value, row, index) {
            //                 return value.length > '14' ? value.slice(0, 14) + '...' : value
            //             }
            //         }, {
            //             field: "goods_unit_name",
            //             title: "单位",
            //             valign: "middle"
            //         }, {
            //             field: "shopping_name",
            //             title: "导购员工",
            //             valign: "middle"
            //         }, {
            //             field: "book_admin_name",
            //             title: "预定人",
            //             valign: "middle"
            //         }, {
            //             field: "sale_quantity",
            //             title: "净销售<br />数量",
            //             valign: "middle"
            //         }, {
            //             field: "quantity",
            //             title: "销售数量",
            //             valign: "middle"
            //         }, {
            //             field: "refund_quantity",
            //             title: "退货数量",
            //             valign: "middle"
            //         }, {
            //             field: "actual_pay",
            //             title: "折后单价",
            //             valign: "middle"
            //         }, {
            //             field: "buying_price",
            //             title: "成本单价",
            //             valign: "middle"
            //         }, {
            //             field: "actual_pay_total",
            //             title: "折后总额",
            //             valign: "middle"
            //         }, {
            //             field: "buying_price_total",
            //             title: "成本总额",
            //             valign: "middle"
            //         }, {
            //             field: "profit_price_total",
            //             title: "利润总额",
            //             valign: "middle"
            //         }, {
            //             field: "deduct_amount",
            //             title: "提成金额",
            //             valign: "middle"
            //         }, {
            //             field: "deduct_rate",
            //             title: "提成<br/>百分比",
            //             valign: "middle"
            //         }],
            //     });
            // },
            // 获取商品销售明细报表
            getOrderList: function(page) {
                let _this = this,
                    shop_id = $(_this.$refs.shop).val(),
                    order_type = [],
                    pay_platform = [],
                    admin_id = $.trim($(_this.$refs.xm_admin).val()),
                    area_ids = '';
                if(_this.order_checkboxModel.length != '0') {
                    for( var i in _this.order_checkboxModel ){
                        order_type.push(_this.order_checkboxModel[i]);
                    }
                }
                if(_this.payment_checkboxModel.length != '0') {
                    for( var i in _this.payment_checkboxModel ){
                        pay_platform.push(_this.payment_checkboxModel[i]);
                    }
                }
                if(_this.xm_area_model != '' && !_this.xm_area_allcheck) {
                    area_ids = _this.xm_area_model.join(',');
                }
                _this.loading = true;
                _this.list_page = page;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.startTime,
                            "end_date": _this.endTime,
                            "shop_id": shop_id,
                            "area_ids": area_ids,
                            "room_id": $.trim($(_this.$refs.xm_box).val()),
                            "goods_type": _this.xm_gtype_item,
                            "order_type": order_type,
                            "pay_platform": pay_platform,
                            "admin_id": admin_id,
                            "shopping_guide": $.trim($(_this.$refs.xm_order_staff).val()),
                            "goods_name": _this.xm_goods_name,
                            "goods_id": _this.xm_goods_id,
                            "vip_card": _this.xm_vip_card,
                            "book_admin_type": $(_this.$refs.xm_tit_sel).val(),
                            "book_admin_name": _this.xm_con_val,
                            "info_type": _this.info_type,
                            "is_blur": _this.blur_query ? '1' : '-1',
                            "room_type_ids": _this.room_type_ids
                        }
                    },
                    "comment": ""

                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGoodsSalesDetailList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        _this.loading = false
                        if(data.response.result_code == "true") {
                            if(page == '1') {
                                _this.list_total = Number(data.response.result.count);
                                $(_this.$refs.xm_quantity).text(data.response.result.quantity_total);
                                $(_this.$refs.xm_sale).text(data.response.result.actual_pay_total);
                                $(_this.$refs.xm_buying).text(data.response.result.buying_price_total);
                                $(_this.$refs.xm_profit).text(data.response.result.profit_price_total);
                            }
                            _this.list_table = data.response.result.data;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            querySearchGood(queryString, cb) {
                var goods_list = this.goods_list;
                var results = queryString ? goods_list.filter(this.createFilter(queryString)) : goods_list;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (goods_list) => {
                    return (goods_list.name.indexOf(queryString) > -1);
                };
            },
           
            handleSelectGood(item) {
                console.log(item);
                this.xm_goods_name = item.name
                this.xm_goods_id = item.id
            },

            // 获取导出设置
            getXmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/getGoodsSalesDetailExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.xmExport_checkModel = data.response.result.export_fields;
                                _this.xmExport_type = data.response.result.export_type;
                            } else {
                                _this.xmExport_checkModel = _this.xmExport_checkData;
                                _this.xmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.xmExport_alert)
                }, function() {
                    _this.exportXmList();
                });
            },
            // 导出字段全选
            xmExportCheckedAll: function() {
                let _this = this;
                _this.xmExport_allcheck = _this.c_xmExport_allcheck;
                if(!_this.xmExport_allcheck) { // 实现全选
                    _this.xmExport_checkModel = [];
                    _this.xmExport_checkData.forEach(function(item) {
                        _this.xmExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.xmExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportXmList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.shop).val(),
                    // store_id = $.trim($(_this.$refs.printer_stock_input).val()),
                    order_type = [],
                    pay_platform = [],
                    area_ids = '';
                if(_this.xm_area_model != '' && !_this.xm_area_allcheck) {
                    area_ids = _this.xm_area_model.join(',');
                }
                let export_fields = JSON.stringify(_this.xmExport_checkModel);
                for( var i in _this.order_checkboxModel ){
                    order_type.push(_this.order_checkboxModel[i]);
                }
                for( var i in _this.payment_checkboxModel ){
                    pay_platform.push(_this.payment_checkboxModel[i]);
                }
                window.location.href = Vue.ctUrl + "FinanceReport/getGoodsSalesDetailExport?bill_type=sales" +
                    "&start_date=" + _this.startTime +
                    "&end_date=" + _this.endTime +
                    "&shop_id=" + shop_id +
                    "&area_ids=" + area_ids +
                    "&room_id=" + $.trim($(_this.$refs.xm_box).val()) +
                    // "&store_id=" + store_id +
                    "&goods_type=" + _this.xm_gtype_item +
                    "&order_type=" + order_type +
                    "&pay_platform=" + pay_platform +
                    "&admin_id=" + $.trim($(_this.$refs.xm_admin).val()) +
                    "&shopping_guide=" + $.trim($(_this.$refs.xm_order_staff).val()) +
                    "&goods_name=" + _this.xm_goods_name +
                    "&goods_id=" + _this.xm_goods_id +
                    "&vip_card=" + _this.xm_vip_card +
                    "&book_admin_type=" + $(_this.$refs.xm_tit_sel).val() +
                    "&book_admin_name=" + _this.xm_con_val +
                    "&info_type=" + _this.info_type +
                    "&is_blur=" + (_this.blur_query?'1':'-1') +
                    "&room_type_ids=" + _this.room_type_ids +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.xmExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .xm-list {
        position: relative;
        .fixed-table-body {
            overflow-x: scroll;
            table {
                width: 2300px;
                max-width: 2300px;
                // table-layout: fixed;
                word-break: break-all;
            }
        }
        .fixed-table-body::-webkit-scrollbar {
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
        }
    }
    .info-type-pop {
        display: none;
        .el-checkbox {
            width: 320px;
            margin-bottom: 10px;
            margin-right: 10px;
        }
    }
</style>